export const copyToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.style.position = 'absolute';
  textArea.style.opacity = 0;
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};
